/**
 * Domains treated as personal/free email (not company signup).
 * Keep in sync with server/src/constants/freeEmailProviders.js
 */
const FREE_EMAIL_PROVIDER_DOMAINS = new Set([
  "gmail.com",
  "outlook.com",
  "hotmail.com",
  "yahoo.com",
  "yahoo.co.in",
  "aol.com",
  "icloud.com",
  "me.com",
  "mac.com",
  "live.com",
  "msn.com",
  "protonmail.com",
  "proton.me",
  "zoho.com",
  "yandex.com",
  "mail.com",
  "gmx.com",
  "rediffmail.com",
]);

export const COMPANY_EMAIL_REQUIRED_MESSAGE =
  "Please sign up with your company email address.";

export function getEmailDomain(email) {
  if (!email || typeof email !== "string" || !email.includes("@")) return "";
  return email.split("@")[1]?.trim().toLowerCase() ?? "";
}

export function isFreeEmailDomain(email) {
  const domain = getEmailDomain(email);
  return domain !== "" && FREE_EMAIL_PROVIDER_DOMAINS.has(domain);
}
